import { DirectiveType } from '../../types';
import { AbstractToggleDirective } from '../abstract-toggle-directive';
export class BlockAllMixedContent extends AbstractToggleDirective {
    getDirectiveName() {
        return 'block-all-mixed-content';
    }
    getDirectiveType() {
        return DirectiveType.Other;
    }
}
